<script setup lang="ts">
    import { cn } from '@/lib/utils';
    import { DialogOverlay, type DialogOverlayProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    const props = defineProps<DialogOverlayProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });
</script>

<template>
    <DialogOverlay
        data-slot="dialog-overlay"
        v-bind="delegatedProps"
        :class="
            cn(
                'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-modal-overlay/50 fixed inset-0 z-50',
                props.class,
            )
        "
    >
        <slot />
    </DialogOverlay>
</template>
